import styled from '@emotion/styled';
import { Empty } from 'antd';

export const SadaKEmpty = styled(Empty)``;
